module.exports = __webpack_public_path__ + "media/images/illustration_1-79c773015fb12d04aaf1e8d5960d682e.png";